module.exports = __webpack_public_path__ + "static/media/credential.e630edd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/RegisterExtension/OrderConfirmation/credential.png
// module id = 1045
// module chunks = 1